import DemoURLMapper from "./DemoURLMapper";
import WithoutUHXURLMapper from "./WithoutUHXURLMapper";

export const getApiUrl = () => {
    // Api call to get the enviornment variables
    return DemoURLMapper;    
    // return WithoutUHXURLMapper;    
};
  